const scrollIntoView = (element: HTMLDivElement) => {
  element.scrollIntoView({ behavior: "smooth" });
};

export { scrollIntoView };
